import CheckIcon from '@mui/icons-material/Check'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import EditIcon from '@mui/icons-material/Edit'
import UndoIcon from '@mui/icons-material/Undo'
import Backdrop from '@mui/material/Backdrop'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import TextField from '@mui/material/TextField'

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import axios from 'api/axios'
import { SnackbarProvider, closeSnackbar, enqueueSnackbar } from 'notistack'

const AccionesSolicitud = ({ solicitud, acciones, sx, editando = false }) => {
  const navigate = useNavigate()
  const [accion, setAccion] = useState(null)
  const [mensaje, setMensaje] = useState(null)
  const [openBackdrop, setOpenBackdrop] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [dialogTextButton, setDialogTextButton] = useState(null)
  const [dialogColorButton, setDialogColorButton] = useState(null)
  const [dialogIconButton, setDialogIconButton] = useState(null)
  const [enEdicion, setEnEdicion] = useState(editando)
  const assets_accion = {
    A: {
      icono: <CheckIcon />,
      texto: 'Aceptar',
      color: 'success',
      confirmacion: false,
      show: true,
    },
    R: {
      icono: <DoDisturbIcon />,
      texto: 'Rechazar',
      color: 'error',
      confirmacion: true,
      show: true,
    },
    D: {
      icono: <UndoIcon />,
      texto: 'Devolver',
      color: 'warning',
      confirmacion: true,
      show: true,
    },
    B: {
      icono: <EditIcon />,
      texto: 'Editar',
      color: 'primary',
      confirmacion: false,
      show: !enEdicion,
    },
    E: {
      icono: <DeleteForeverIcon />,
      texto: 'Eliminar',
      color: 'error',
      confirmacion: false,
      show: true,
    },
  }

  const ejecutarAccion = (accion_seleccionada = null) => {
    setOpenBackdrop(true)

    const datos = {
      codigo_solicitud: solicitud.codigo_solicitud,
      origen_solicitud: solicitud.origen_solicitud,
      accion: accion_seleccionada ?? accion,
      mensaje,
    }
    axios
      .patch(`/solicitudpendiente/validar/`, datos)
      .then((response) => {
        enqueueSnackbar(`Solicitud actualizada`)
        navigate('/pendientes/')
      })
      .catch((e) =>
        enqueueSnackbar(
          <Box>
            <Typography>Se ha producido un error al validar la solicitud.</Typography>
            <Typography variant="subtitle2">Por favor, inténtelo de nuevo más tarde.</Typography>
          </Box>,
        ),
      )
      .finally(() => setOpenBackdrop(false))
  }

  const accionHandler = (e) => {
    const accion_seleccionada = e.currentTarget.dataset.accion
    setAccion(accion_seleccionada)
    const infoAccion = assets_accion[accion_seleccionada]

    if (infoAccion.confirmacion) {
      setDialogTextButton(infoAccion?.texto)
      setDialogColorButton(infoAccion?.color)
      setDialogIconButton(infoAccion?.icono)
      setOpenDialog(true)
      return
    }

    if (accion_seleccionada === 'B') {
      navigate(`/solicitud/`, { state: { solicitud, editando: true } })
      return
    }
    ejecutarAccion(accion_seleccionada)
  }

  const handleConfirmDialog = () => {
    setOpenDialog(false)
    ejecutarAccion()
  }

  const handleDismissDialog = () => {
    setOpenDialog(false)
  }

  return (
    <>
      <Dialog open={openDialog} onClose={handleDismissDialog}>
        <DialogTitle>Observaciones</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Aquí puede añadir alguna informción para el usuario solicitante
          </DialogContentText>
          <TextField
            autoFocus
            id="observaciones"
            label="Observaciones"
            type="text"
            fullWidth
            variant="standard"
            value={mensaje}
            onChange={(e) => {
              setMensaje(e.target.value)
            }}
            multiline
            rows={4}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDismissDialog}>Cancelar</Button>
          <Button
            color={dialogColorButton}
            startIcon={dialogIconButton}
            onClick={handleConfirmDialog}
          >
            {dialogTextButton}
          </Button>
        </DialogActions>
      </Dialog>
      <SnackbarProvider
        autoHideDuration={6000}
        action={(snackbarId) => (
          <IconButton onClick={() => closeSnackbar(snackbarId)} aria-label="cerrar">
            <CloseRoundedIcon />
          </IconButton>
        )}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        variant={'error'}
      />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>{' '}
      <Box sx={{ ...sx }}>
        {acciones?.map((a, i) => {
          return a && assets_accion[a]?.show ? (
            <Button
              key={i}
              variant="contained"
              color={assets_accion[a]?.color}
              startIcon={assets_accion[a]?.icono}
              data-accion={a}
              onClick={accionHandler}
            >
              {assets_accion[a]?.texto}
            </Button>
          ) : (
            ''
          )
        }) ?? <></>}
      </Box>
    </>
  )
}

export default AccionesSolicitud
